<template>
	<div>
		<div class="bjMy12">
			<div class="message13">
				<div class="mess-img" @click="layoutClick">
					<img src="@/assets/Group 1271@2x.png" style="height: 35px; width: 35px" />
				</div>
				<div>
					<div class="message-title">详情</div>
				</div>
				<div class="message-border"></div>
				<div style="height: 15px"></div>
				<div class="meass-appd">
					<div class="title-mesa">订单ID:</div>
					<span>{{ obhList.no }}</span>
				</div>
				<div class="border-top"></div>
				<div class="meass-appd">
					<span class="title-mesa">订单状态:</span>
					<span>{{ formatOrderStatus(obhList) }}</span>
				</div>
				<div class="border-top1"></div>
				<div class="meass-appd">
					<span class="title-mesa">用户ID:</span>
					<span>{{ obhList.userId }}</span>
				</div>
				<div class="border-top1"></div>
				<div class="meass-appd">
					<span class="title-mesa">卡种:</span>
					<span>{{ cardInfoStr }}</span>
				</div>
				<div class="border-top1"></div>
				<div class="meass-appd">
					<span class="title-mesa">提交面值:</span>
					<span>{{ obhList.sourcePrice }}</span>
				</div>
				<div class="border-top1"></div>
				<div class="meass-appd">
					<span class="title-mesa">回收价:</span>
					<span>{{ obhList.price }}</span>
				</div>
				<div class="border-top1"></div>
				<div class="meass-appd">
					<span class="title-mesa">实际面值:</span>
					<span>{{ obhList.realAmount }}</span>
				</div>
				<div class="border-top1"></div>
				<div class="meass-appd">
					<span class="title-mesa">实付金额:</span>
					<span>{{ obhList.realPay }}</span>
				</div>
				<div class="border-top1"></div>
				<div class="meass-appd">
					<span class="title-mesa">提交时间:</span>
					<span>{{ formatTime(obhList.createTime) }}</span>
				</div>
				<div class="border-top1"></div>
				<div class="meass-appd">
					<span class="title-mesa">提交时间:</span>
					<span>{{ formatTime(obhList.passTime) }}</span>
				</div>
				<div class="border-top1"></div>
				<div class="meass-appd">
					<span class="title-mesa">处理结果:</span>
					<span>--</span>
				</div>
				<div class="border-top1"></div>
				<div class="meass-appd">
					<span class="title-mesa">支付方式:</span>
					<span class="con">{{ obhList.status === 1 ? '存入余额' : '--' }}</span>
				</div>
				<div class="border-top1"></div>
				<div class="meass-appd">
					<span class="title-mesa">卡号卡密:</span>
					<div v-for="(d, index) in cardBody" :key="index">
					  {{ d.pwd }}/{{ d.code }}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { cardOrderDetail } from '@/utils/api.js';
import dayjs from 'dayjs';
let props = defineProps(['orderId']);
let obhList = ref({});
let cardInfoStr = ref('');
let cardBody = ref([]);
let emit = defineEmits(['ckilfOrder']);
const info = async () => {
	let res = await cardOrderDetail({
		orderId: props.orderId,
	});
	obhList.value = res.data;
	cardInfoStr.value = JSON.parse(res.data.cardInfoStr).name;
	cardBody.value = JSON.parse(res.data.cardBody);
};
const formatOrderStatus = (order) => {
	console.log(order);
	if (order.status === 0) {
		return '处理中';
	}
	if (order.status === 1) {
		return '交易成功';
	}
	if (order.status === 2) {
		return '交易失败';
	}
	return '';
};

const formatTime = (time) => {
	if (!time) {
		return '--';
	}
	return dayjs(time).format('YYYY-MM-DD HH:mm:ss');
};

const layoutClick = () =>{
	emit('ckilfOrder');
}

onMounted(() => {
	info();
});
</script>

<style lang="scss">
.bjMy12 {
	position: fixed;
	width: 100%;
	height: calc(100% - 70px);
	background: rgba(0, 0, 0, 0.7);
	z-index: 1000;
	bottom: 0;
	left: 0;
	display: flex;
	align-items: center;
	justify-content: center;
}

.meass-appd {
	margin-left: 20px;
	display: flex;
}

.border-top1 {
	width: 92%;
	height: 0px;
	border-top: 1px solid #eeeeee;
	padding-top: 14px;
	margin-top: 14px;
	margin-left: 20px;
}

.message13 {
	width: 558px;
	height: 786px;
	background: #ffffff;
	border-radius: 8px 8px 8px 8px;
	position: relative;
}

.title-mesa {
	width: 100px;
}

.mess-img {
	position: absolute;
	right: -15px;
	top: -15px;
}

.message-title {
	font-family: PingFang SC, PingFang SC;
	font-weight: 600;
	font-size: 20px;
	color: #333333;
	text-align: center;
	font-style: normal;
	text-transform: none;
	margin-top: 21px;
}
.message-border {
	width: 100%;
	height: 0px;
	border-top: 1px solid #eeeeee;
	margin-top: 11px;
}

.slicess {
	padding: 0px 40px;
}
.slicess-padd {
	margin-top: 22px;
}

.title-sliceS {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #333333;
	font-style: normal;
	text-transform: none;
}
.title-time1 {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #aaaaaa;
	font-style: normal;
	text-transform: none;
	margin-top: 7px;
}

.pagination-contact1 {
	position: absolute;
	bottom: 30px;
	left: 50px;
}

.user-nickname {
	width: 310px;
	height: 42px;
	border-radius: 4px 4px 4px 4px;
	border: 1px solid #eeeeee;
	margin-left: 22px;
	margin-top: 24px;
	display: flex;
}

.flex-nickname {
	display: flex;
	align-items: center;
}

.inputClat {
	border: none;
	width: 180px;
	margin-left: 5px;
	font-size: 16px;
}

.inputClat::placeholder {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #777777;
	font-style: normal;
	text-transform: none;
}

.inputClat:focus {
	outline: none;
	border: none;
}

.name-assets {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #333333;
	font-style: normal;
	text-transform: none;
}

.sure-you-want {
	width: 310px;
	height: 52px;
	background: #ff3333;
	border-radius: 4px 4px 4px 4px;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #ffffff;
	line-height: 52px;
	text-align: center;
	font-style: normal;
	text-transform: none;
	margin-top: 32px;
	margin-left: 24px;
}
</style>
